import { render, staticRenderFns } from "./LightTotal.vue?vue&type=template&id=46d71181&scoped=true"
import script from "./LightTotal.vue?vue&type=script&lang=js"
export * from "./LightTotal.vue?vue&type=script&lang=js"
import style0 from "./LightTotal.vue?vue&type=style&index=0&id=46d71181&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d71181",
  null
  
)

export default component.exports